/**
 * Leadoo chatbot and lead forms (<ld-slot>), loaded after the page instead of in <head>: on the first
 * interaction (scroll, tap, key press) or 5 s after the page has loaded, whichever comes first.
 * The bot script is large and its work used to compete with the page's own rendering.
 */
const LEADOO_SRC = 'https://bot.leadoo.com/bot/dynamic.js?company=JVFGQWlg&mode=spa'
const INTERACTIONS = ['scroll', 'pointerdown', 'keydown', 'touchstart'] as const
const DELAY_AFTER_LOAD_MS = 5000

export default defineNuxtPlugin(() => {
  let loaded = false

  const load = () => {
    if (loaded) return
    loaded = true
    INTERACTIONS.forEach(event => window.removeEventListener(event, load))
    const script = document.createElement('script')
    script.id = 'leadoo'
    script.src = LEADOO_SRC
    script.async = true
    document.head.appendChild(script)
  }

  INTERACTIONS.forEach(event => window.addEventListener(event, load, { once: true, passive: true }))
  const loadLater = () => setTimeout(load, DELAY_AFTER_LOAD_MS)
  if (document.readyState === 'complete') {
    loadLater()
  }
  else {
    window.addEventListener('load', loadLater, { once: true })
  }
})
